export default __webpack_public_path__ + "static/media/logo_gigabarians.7ca66364.svg";